import { createStore } from 'vuex';

import { getById, getLogsById } from '@/api/providers/reports';
import { get as getImages } from '@/api/providers/photo-gallery/report';

export const State = {
  loading: 1,
  loaded: 2,
  error: 3
};

const fetchLogs = async id => {
  try {
    let items = await getLogsById(id)
    items.reverse();
    return items;
  } catch {
    return [];
  }
}

const fetchImages = async id => {
  try {
    return await getImages(id);
  } catch {
    console.error('Error fetching images');
    return [];
  }
}

const extractImages = images => 
  (images?.photoGalleryImages ?? []).map(i => i.visualImage);


const store = createStore({
  state() {
    return {
      report: null,
      logs: null,
      state: State.loading,

      images: null,

      forwarding: {
        email: '',
        message: '',
      }
    };
  },

  getters: {
    report: state => state.report,
    logs: state => state.logs,
    images: state => state.images ?? [],
    state: state => state.state,
    forwardingEmail: state => state.forwarding.email,
    forwardingMessage: state => state.forwarding.message,
    isLoading: state => state.state === State.loading,
    isLoaded: state => state.state === State.loaded,
    isError: state => state.state === State.error,
  },

  mutations: {
    updateReport: (state, payload) => state.report = payload,
    updateLogs: (state, payload) => state.logs = payload,
    updateImages: (state, payload) => state.images = payload,
    updateForwardingEmail: (state, payload) => state.forwarding.email = payload,
    updateForwardingMessage: (state, payload) => state.forwarding.message = payload,
    clearForwarding: state => state.forwarding = { email: '', message: '' },
    updateState: (state, payload) => state.state = payload,
  },

  actions: {
    loadReport: async ({commit}, id) => {
      try {
        let data = await Promise.all([
          getById(id), 
          fetchLogs(id),
          fetchImages(id)
        ]);

        commit('updateReport', data[0]);

        commit(
          'updateLogs', 
          data[1]
        );

        commit(
          'updateImages', 
          [data[0].visualImage, ...extractImages(data[2])]
        );

        commit('updateState', State.loaded);
      } catch(e) {
        console.error(e);
        commit('updateState', State.error);

      }
    },

    updateForwardingEmail: ({commit}, payload) => {
      commit('updateForwardingEmail', payload);
    },

    updateForwardingMessage: ({commit}, payload) => {
      commit('updateForwardingMessage', payload);
    },

    updateReport: ({commit}, payload) =>
      commit('updateReport', payload),

    updateReportStatus: ({commit, state}, payload) => {
      commit('updateReport', 
        {
          ...state.report,
          reportStatus: payload
        }
      );
    },

    addLogItem: ({commit, state}, payload) => {
      commit('updateLogs', 
        [
          payload,
          ...state.logs,
        ]
      );
    },
    
    updateLogItems: ({commit}, payload) => {
      commit('updateLogs', payload);
    },
  }
});

export default store;